<div class="footer" *transloco="let t">
  <p class="text-small bold">Curamenta®</p>
  @if(consents().imprint) {
  <a
    [href]="consents().imprint"
    [xTentionDummyCypress]="'footer.consents().imprint.navigate'"
    class="text-small"
    target="_blank"
    >{{ t('app.footer.imprint') }}
  </a>
  } @if(consents().privacyPolicy) {
  <a
    [xTentionDummyCypress]="'footer.privacy-policy.navigate'"
    class="text-small"
    target="_blank"
    [href]="consents().privacyPolicy"
    >{{ t('app.footer.privacyPolicy') }}
  </a>
  } @if(consents().termsOfUse) {
  <a
    [xTentionDummyCypress]="'footer.termsofuse.navigate'"
    class="text-small"
    [href]="consents().termsOfUse"
    target="_blank"
    >{{ t('app.footer.termsOfUse') }}
  </a>
  }

  <p class="text-small bold">{{ portalVersion$ | async }}</p>
</div>
